import { render, staticRenderFns } from "./ManifestoSaidaForm.vue?vue&type=template&id=fd2c302c&scoped=true&"
import script from "./ManifestoSaidaForm.vue?vue&type=script&lang=js&"
export * from "./ManifestoSaidaForm.vue?vue&type=script&lang=js&"
import style0 from "./ManifestoSaidaForm.vue?vue&type=style&index=0&id=fd2c302c&scoped=true&lang=css&"
import style1 from "./ManifestoSaidaForm.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2c302c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VIcon,VRow,VTooltip})
